import { ModuleSetting, Contract, NewContract, Product } from "@models";
import _ from "lodash";

export default function checkCorrespondingModuleSetting(
	contract: Contract | NewContract,
	moduleSettings: ModuleSetting[],
	product: Product
) {
	const now = new Date(Date.now());

	const overlappingModuleSettings = moduleSettings.filter((ms) => {
		if (ms.availableUntil) {
			return (
				contract.startDate <= ms.availableUntil &&
				(!contract.endDate || contract.endDate >= ms.availableFrom)
			);
		} else {
			return !contract.endDate || contract.endDate >= ms.availableFrom;
		}
	});

	if (overlappingModuleSettings.length === 0) return false;

	const activeModuleSettings = overlappingModuleSettings.filter(
		(ms) =>
			ms.availableFrom <= now &&
			((ms.availableUntil && ms.availableUntil >= now) || !ms.availableUntil)
	);

	const budgetCategoryCandidates = _.flatMap(
		product.variants,
		(v) => v.budgetCategories
	)
		.filter((bc) => bc.findCategory(contract.category) !== undefined)
		.map((bc) => bc.id);

	const hasCorrespondingModuleSettings = activeModuleSettings.some((ms) => {
		const hasCorrespondingAmount = ms.amounts.some((amount) =>
			budgetCategoryCandidates.includes(amount.category)
		);
		const correspondingCategories = ms.categories.some(
			(category) => category === contract.category
		);

		if (contract.category === "web") {
			// here we have no sub-categories to enable
			return hasCorrespondingAmount;
		}
		return hasCorrespondingAmount && correspondingCategories;
	});

	return hasCorrespondingModuleSettings;
}
